import {
    styled,
    Table,
    TableCell,
    tableCellClasses,
    TableRow,
} from "@mui/material"

export const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        // backgroundColor: "#e3eae9",
        backgroundColor: "#F0F5FF",
    },
}))

export const StyledTableRow = styled(TableRow)(() => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#f7f7f9",
    },
}))

export const StyledTable = styled(Table)(() => ({
    [`& .${tableCellClasses.root}`]: {
        borderRight: "none",
        borderBottom: "none",
    },
}))
